<div *ngIf="withUpload; else signContent">
  <nav>
    <div class="nav nav-tabs" id="nav-tab" role="tablist">
      <button class="nav-link" [class.active]="activeTab === 'sign'" type="button" (click)="setActiveTab('sign')">{{'doc.signature_tab.sign' | translate }}</button>
      <button class="nav-link" [class.active]="activeTab === 'img'" type="button" (click)="setActiveTab('img')">{{'doc.signature_tab.image' | translate }}</button>
      <button class="nav-link" [class.active]="activeTab === 'stamp'" type="button" (click)="setActiveTab('stamp')">{{'doc.signature_tab.stamp' | translate }}</button>
    </div>
  </nav>
  <div class="tab-content" id="nav-tabContent">
    <div class="tab-pane fade show active" *ngIf="activeTab === 'sign'">
      <ng-container *ngTemplateOutlet="signContent"></ng-container>
    </div>
    <div class="tab-pane fade show active" *ngIf="activeTab === 'img'">
      <ng-container *ngTemplateOutlet="imgContent"></ng-container>
    </div>
    <div class="tab-pane fade show active" *ngIf="activeTab === 'stamp'">
      <ng-container *ngTemplateOutlet="stampContent"></ng-container>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12 mt-2" *ngIf="!driverView">
    <button class="btn btn-success w-100" [disabled]="!checkEnabledSave()"  
    (click)="savePNG()">{{'doc.signature_pad.save' | translate }}</button>
  </div>
</div>

<ng-template #signContent>
  <div class="signature-pad">
    <div class="signature-pad-body">
      <canvas #sPad width="450%" height="100%" style="touch-action: none;"></canvas>
    </div>
    <div class="signature-pad-footer">
      <span>{{'doc.signature_pad.signDescription' | translate }}</span>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-6" *ngIf="!driverView">
      <button class="btn btn-secondary w-100" (click)="undo()">{{'doc.signature_pad.undo' | translate }}</button>
    </div>
    <div class="col-6">
      <button class="btn btn-danger w-100" (click)="clear()">{{'doc.signature_pad.clear' | translate }}</button>
    </div>
    <div class="col-6" *ngIf="driverView">
      <button class="btn btn-success w-100" [disabled]="!checkEnabledSave()"  
    (click)="savePNG()">{{'doc.signature_pad.save' | translate }}</button>
    </div>
  </div>
</ng-template>

<ng-template #imgContent>
  <div class="signature-pad">
    <div class="signature-pad-body">
      <img class="uplimg" *ngIf="!!filePath" [src]="filePath" width="100%" height="100%" alt="imgsign">
    </div>
    <div class="signature-pad-footer">
      <span>{{'doc.signature_pad.imgDescription' | translate }}({{this.allowedExtensionsText}})</span>
    </div>
  </div>  
  <br>
  <div class="row">
    <div class="col-6">
      <button class="btn btn-danger w-100" (click)="clear()">{{'doc.signature_pad.clear' | translate }}</button>
    </div>
    <div class="col-6">
      <input type="file" accept={{this.acceptedExtensionsText}} hidden #fileUpload class="file-upload"
        (change)="previewNg($event)">
      <button class="btn btn-info w-100" (click)="fileUpload.click()">
        {{'doc.signature_pad.upload' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #stampContent>
  <div class="signature-pad">
    <div class="signature-pad-body">
      <img class="uplimg" *ngIf="!!filePath" [src]="filePath" width="100%" height="100%" alt="imgsign">
    </div>
    <div class="signature-pad-footer">
      <span>{{'doc.signature_pad.stampDescription' | translate }}({{this.allowedExtensionsText}})</span>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-6">
      <button class="btn btn-danger w-100" (click)="clear()">{{'doc.signature_pad.clear' | translate }}</button>
    </div>
    <div class="col-6">
      <input type="file" accept={{this.acceptedExtensionsText}} hidden [imageToDataUrl]="options" #fileUploadStamp class="file-upload"
        (change)="previewNg($event)">
      <button class="btn btn-info w-100" (click)="fileUploadStamp.click()">
        {{'doc.signature_pad.upload' | translate }}
      </button>
    </div>
  </div>
</ng-template>